/**
 * @generated SignedSource<<8ef3b5d116c6b1b3ecb9946569178ab2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateAICustomAppInput = {
  aiCustomAppID: number;
  description?: string | null;
  isActive: boolean;
  name: string;
  scope: string;
  workflowExternalId: string;
  workflowGuid: any;
  workflowInterfaceId: string;
};
export type aiCustomAppsUpdateMutation$variables = {
  input: UpdateAICustomAppInput;
};
export type aiCustomAppsUpdateMutation$data = {
  readonly updateAICustomApp: {
    readonly aiCustomAppID: number;
    readonly description: string | null;
    readonly isActive: boolean;
    readonly mediaFactoryAppID: number;
    readonly name: string;
  };
};
export type aiCustomAppsUpdateMutation = {
  response: aiCustomAppsUpdateMutation$data;
  variables: aiCustomAppsUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AICustomApp",
    "kind": "LinkedField",
    "name": "updateAICustomApp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aiCustomAppID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mediaFactoryAppID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aiCustomAppsUpdateMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "aiCustomAppsUpdateMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "e42411cfc02f2f2e70a52acbc5f38c27",
    "id": null,
    "metadata": {},
    "name": "aiCustomAppsUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation aiCustomAppsUpdateMutation(\n  $input: UpdateAICustomAppInput!\n) {\n  updateAICustomApp(input: $input) {\n    aiCustomAppID\n    name\n    description\n    mediaFactoryAppID\n    isActive\n  }\n}\n"
  }
};
})();

(node as any).hash = "b5818be1cecbad5e78c4a5974f51aeae";

export default node;
